/* Crunch sound, loaded on every page from snippets/snacc-cart-drawer.liquid.
   Every add-to-bag button ("snacc IT +", "snacc +", "snacc THIS BOX +", the cart drawer's "Add +", "Add to bag")
   plays a short bite-crunch when tapped. The sound is made in the browser (Web Audio), so there is no file to
   load: a few tiny filtered crackles in quick succession over a soft low "bite", about 0.15 s long and different
   every time. Buttons that are disabled or say "sold out" stay silent. iPhones with the ring/silent switch on silent
   don't play website sounds at all; that is the phone's rule and is left alone so shoppers' music isn't interrupted. */
(function () {
  var AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return;
  var VOLUME = 1; // overall loudness (0 to 1)
  var ctx = null, noise = null, last = -1;

  function setup() {
    if (ctx) return true;
    try { ctx = new AC(); } catch (e) { return false; }
    // half a second of crackly noise (white noise with sharpened peaks)
    var len = Math.floor(ctx.sampleRate * 0.5), buf = ctx.createBuffer(1, len, ctx.sampleRate), d = buf.getChannelData(0);
    for (var i = 0; i < len; i++) { var w = Math.random() * 2 - 1; d[i] = w * w * w * (Math.random() < 0.06 ? 2.2 : 1); }
    noise = buf;
    return true;
  }
  function crackle(at, peak, dur, freq, q, dest) {
    var src = ctx.createBufferSource(); src.buffer = noise;
    var bp = ctx.createBiquadFilter(); bp.type = 'bandpass'; bp.frequency.value = freq; bp.Q.value = q;
    var hp = ctx.createBiquadFilter(); hp.type = 'highpass'; hp.frequency.value = 450;
    var g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, at);
    g.gain.exponentialRampToValueAtTime(peak, at + 0.0015);
    g.gain.exponentialRampToValueAtTime(0.0001, at + dur);
    src.connect(bp); bp.connect(hp); hp.connect(g); g.connect(dest);
    src.start(at, Math.random() * 0.4, dur + 0.02);
  }
  function crunch() {
    if (!setup()) return;
    if (ctx.state === 'suspended' && ctx.resume) ctx.resume();
    var now = ctx.currentTime + 0.01;
    if (now - last < 0.12) return; // no machine-gun crunches on double taps
    last = now;
    // loud and even on small phone speakers: squash the peaks, then bring the whole crunch up
    var comp = ctx.createDynamicsCompressor();
    comp.threshold.value = -26; comp.knee.value = 6; comp.ratio.value = 8; comp.attack.value = 0.001; comp.release.value = 0.08;
    var out = ctx.createGain(); out.gain.value = 2 * VOLUME;
    var master = ctx.createGain(); master.gain.value = 1;
    master.connect(comp); comp.connect(out); out.connect(ctx.destination);
    // soft low "bite" under the crackles
    var thump = ctx.createBufferSource(); thump.buffer = noise;
    var lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 900;
    var tg = ctx.createGain();
    tg.gain.setValueAtTime(0.0001, now); tg.gain.exponentialRampToValueAtTime(0.9, now + 0.004); tg.gain.exponentialRampToValueAtTime(0.0001, now + 0.06);
    thump.connect(lp); lp.connect(tg); tg.connect(master); thump.start(now, Math.random() * 0.3, 0.08);
    // the crunch: 5 to 8 crackles over about 0.14 s, loudest first
    var n = 5 + Math.floor(Math.random() * 4), t = now;
    for (var i = 0; i < n; i++) {
      var peak = i === 0 ? 0.9 : (0.25 + Math.random() * 0.55) * (1 - i / (n + 2));
      crackle(t, peak, 0.014 + Math.random() * 0.03, 900 + Math.random() * 2600, 0.7 + Math.random() * 1.2, master);
      t += 0.008 + Math.random() * 0.026;
    }
  }
  var ADD = /^\s*(snacc\b[\s\S]*\+|add\b[\s\S]*(\+|bag|snacc))/i;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button, [role="button"], a.snacc-button');
    if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true') return;
    if (b.classList.contains('snacc-pill') || b.classList.contains('snacc-search-btn')) return;
    var text = (b.textContent || '').replace(/\s+/g, ' ').trim();
    if (/sold out|in the bag|added|✓/i.test(text)) return;
    if (!ADD.test(text) && !b.hasAttribute('data-cart-add') && !b.hasAttribute('data-snacc-add') && !b.hasAttribute('data-snacc-sticky-add')) return;
    crunch();
  }, true);
  window.SnaccCrunch = crunch;
})();
